// Integrazione ufficiale dei geoservizi dell'Osservatorio Turistico regionale.
// Il catalogo e i dati passano dal BFF same-origin: nessun URL arbitrario entra
// nel browser e ogni dataset conserva fonte, licenza, freshness e attribuzione.

const API = '/api/forecast-map.php?mode=geoportale-sicilia&';
const EMPTY = { type: 'FeatureCollection', features: [] };
const STORAGE_KEY = 'wsv2-geoportale-enabled';
const CATEGORY_ORDER = ['culture', 'nature', 'accommodation', 'studies', 'historical', 'misc'];
const DEMO_KEYS = [
    'cultura-borghi-0',
    'cultura-musei-teatri-antichi-siti-unesco-sicilia-0',
    'natura-outdoor-e-spiagge-1',
    'natura-sentieri-e-cammini-0',
    'accommsdigitale-accommodation-alb-2',
];
const LAYER_LABELS = {
    'cultura-archeo-pal-edb-web-0': 'Siti archeologici di Palermo',
    'cultura-archeo-pal-edb-web-1': 'Aree dei siti archeologici di Palermo',
    'cultura-husky-campaign-2': 'Luoghi dell’Operazione Husky',
    'cultura-husky-campaign-3': 'Linea del fronte dell’Operazione Husky',
    'cultura-husky-campaign-4': 'Movimenti dell’Operazione Husky',
    'cultura-husky-events-0': 'Eventi dell’Operazione Husky',
    'cultura-husky-media-0': 'Contenuti multimediali dell’Operazione Husky',
    'accommsdigitale-accommodationswebgis-0': 'Catalogo completo delle strutture ricettive',
    'natura-aammpp-di-sicilia-0': 'Uffici e centri informativi delle aree marine protette',
    'natura-aammpp-di-sicilia-1': 'Punti d’immersione nelle aree marine protette',
    'natura-aammpp-di-sicilia-2': 'Boe di ormeggio nelle aree marine protette',
    'natura-porti-approdi-fari-e-fanali-4': 'Distanze nautiche tra porti',
    'natura-porti-approdi-fari-e-fanali-1': 'Fari e segnalamenti marittimi',
};
const SERVICE_LABELS = {
    'Archeo Pal Edb Web': 'Patrimonio archeologico',
    'Accommodation alb': 'Ricettività alberghiera regionale',
    'Accommodation aabb': 'Affitti brevi regionali',
    'AccommodationsWebGIS': 'Ricettività regionale',
    'AAMMPP di Sicilia': 'Aree marine protette della Sicilia',
    'Cammini topo profile': 'Cammini e itinerari',
    'Husky campaign': 'Operazione Husky',
    'Husky events': 'Operazione Husky',
    'Husky media': 'Operazione Husky',
    'Province limiti': 'Quadro territoriale provinciale',
};
const FIELD_LABELS = {
    accomdesc: 'Nome della struttura', tipology: 'Tipologia', classification: 'Classificazione',
    geogcoordinates: 'Coordinate', address: 'Indirizzo', geogareaname: 'Comune o area geografica',
    entitycod: 'Codice interno della struttura', geogareacod: 'Codice dell’area geografica',
    website: 'Sito web', e_mail: 'Email', email2: 'Email', tel: 'Telefono', telefono: 'Telefono',
    circode: 'Codice identificativo regionale (CIR)', cincode: 'Codice identificativo nazionale (CIN)',
    denom: 'Denominazione', denomi: 'Denominazione', denominazi: 'Denominazione', denomin: 'Denominazione',
    denomi_it: 'Denominazione italiana', denom_it: 'Denominazione italiana', name: 'Nome', nome: 'Nome',
    localiz: 'Localizzazione', localizzaz: 'Localizzazione', localita_: 'Località', place: 'Luogo',
    prov: 'Provincia', proat: 'Proprietà attuale', prop_att: 'Proprietà attuale',
    tipo: 'Tipologia', type: 'Tipologia', sotto_tipo: 'Sottotipo', categ: 'Categoria',
    cons: 'Stato di conservazione', conservazi: 'Stato di conservazione', stato_cons: 'Stato di conservazione',
    uso_att: 'Uso attuale', cronologia: 'Cronologia', crono_acro: 'Periodo storico', anno_iscri: 'Anno di iscrizione UNESCO',
    fonte_dati: 'Fonte dei dati', fontedati: 'Fonte dei dati', datasource: 'Fonte dei dati',
    allied: 'Forze alleate', axis: 'Forze dell’Asse', date_bg: 'Data di inizio', date_end: 'Data di conclusione',
    note_: 'Note', note_1: 'Note', notes: 'Note', note2: 'Note', descriptio: 'Descrizione', descriz: 'Descrizione',
    sintesi: 'Descrizione', abstract: 'Approfondimento', info: 'Informazioni', orario: 'Orari',
    ticket: 'Biglietto intero', ticket_rid: 'Biglietto ridotto', visitabile: 'Visitabile',
    weblink: 'Sito o scheda informativa', web_link: 'Sito o scheda informativa', url_link: 'Sito ufficiale',
    link_sched: 'Scheda informativa', scheda: 'Scheda informativa', gpx: 'Traccia GPX',
    fotolink: 'Fotografia', foto_link: 'Fotografia', image_link: 'Immagine', imagelink: 'Immagine', immagine: 'Immagine',
    comune: 'Comune', provincia: 'Provincia', indirizzo: 'Indirizzo', recapiti: 'Contatti', gestore: 'Gestore',
    comuni: 'Comune', propriet: 'Proprietà o gestione', ult_rev: 'Ultimo aggiornamento',
    lat_n: 'Latitudine', latn: 'Latitudine', latitude: 'Latitudine',
    long_e: 'Longitudine', longe: 'Longitudine', longitude: 'Longitudine',
    specie: 'Specie', età_stima: 'Età stimata', altezza: 'Altezza', circonf: 'Circonferenza',
    percorso: 'Percorso', cammino: 'Cammino', tappa: 'Tappa', tempo_perc: 'Tempo di percorrenza',
    difficolt: 'Difficoltà', lunghezza: 'Lunghezza', lungint: 'Lunghezza della tappa',
    ibp_bike: 'Indice di difficoltà in bicicletta (IBP)', ibp_hike_num: 'Indice di difficoltà escursionistica (IBP)',
    link_3d: 'Visualizzazione 3D', link_profi: 'Profilo altimetrico', largh: 'Larghezza del sentiero',
    bacino: 'Bacino idrografico', origine: 'Origine', natura: 'Natura', area__ha_: 'Superficie',
    depth: 'Profondità', prof: 'Profondità', magnitude: 'Magnitudo', magtype: 'Tipo di magnitudo',
    eventlocationname: 'Area dell’evento', location: 'Localizzazione', time: 'Data e ora',
    posti_barc: 'Posti barca', lungh_max: 'Lunghezza massima imbarcazione', vhf_canale: 'Canale VHF',
    locamare_e: 'Autorità marittima competente', num_eff: 'Numero identificativo del faro',
    val_storic: 'Valore storico', anno_att: 'Anno di attivazione', caratter_1: 'Caratteristica luminosa',
    portata: 'Portata luminosa', boa_n: 'Numero della boa', boan: 'Numero della boa', amp: 'Area marina protetta',
    nome_porto: 'Nome del porto', distanza__: 'Distanza', da: 'Porto di partenza', a: 'Porto di arrivo',
    blu_18: 'Bandiera Blu 2018', blu_21: 'Bandiera Blu 2021', blu_24: 'Bandiera Blu 2024',
    classifica: 'Classificazione o riconoscimento', riconosc: 'Riconoscimento', media: 'Video',
    demanio_ri: 'Demanio forestale', postiletto: 'Posti letto', posti: 'Posti disponibili',
};
const TECHNICAL_FIELD = /(^|[._])(objectid(?:_\d+)?|fid|shape(?:_length|_area|_leng|\.stlength\(\)|\.starea\(\))?|globalid|symbolid|attachid|countattachments|esri_oid|uniqueid)$/i;

const state = {
    map: null,
    catalog: null,
    catalogPromise: null,
    enabled: new Set(),
    loading: new Set(),
    wired: new Set(),
    controls: null,
    popup: null,
};

function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>"']/g, ch => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
    }[ch]));
}

function safeUrl(value) {
    try {
        const url = new URL(String(value));
        return ['http:', 'https:'].includes(url.protocol) ? url.href : null;
    } catch (e) { return null; }
}

function prettyLayerTitle(item) {
    const title = LAYER_LABELS[item.key] || String(item.title || item.service_title || 'Layer regionale')
        .replace(/\.(?:jpe?g|png|tiff?)$/i, '').replace(/[_]+/g, ' ').replace(/\s+/g, ' ').trim();
    return title ? title.charAt(0).toLocaleUpperCase('it') + title.slice(1) : 'Layer regionale';
}

function prettyServiceTitle(item) {
    const service = String(item.service_title || '').replace(/[_]+/g, ' ').replace(/\s+/g, ' ').trim();
    return SERVICE_LABELS[service] || service || item.category_label;
}

function fieldToken(value) {
    return String(value || '').split('.').pop().trim();
}

function fieldLabel(field) {
    const name = fieldToken(field.name);
    const alias = fieldToken(field.alias);
    const normalized = name.toLocaleLowerCase('it');
    if (FIELD_LABELS[normalized]) return FIELD_LABELS[normalized];
    const yearMetric = normalized.match(/^(nalb|nextra|ntot|pres|arr)_?(\d{2,4})$/);
    if (yearMetric) {
        const metric = { nalb: 'Strutture alberghiere', nextra: 'Strutture extralberghiere', ntot: 'Totale strutture', pres: 'Presenze', arr: 'Arrivi' }[yearMetric[1]];
        return `${metric} (${yearMetric[2]})`;
    }
    let label = alias && !/^(field|shape|fid|objectid)$/i.test(alias) ? alias : name;
    label = label.replace(/[_]+/g, ' ').replace(/([a-zà-ÿ])([A-Z])/g, '$1 $2').replace(/\s+/g, ' ').trim();
    const substitutions = { amp: 'Area marina protetta', rn: 'Riserva naturale', eg: 'Ente gestore', gpsx: 'Longitudine', gpsy: 'Latitudine', latn: 'Latitudine', longe: 'Longitudine' };
    if (substitutions[label.toLocaleLowerCase('it')]) return substitutions[label.toLocaleLowerCase('it')];
    return label ? label.charAt(0).toLocaleUpperCase('it') + label.slice(1) : 'Informazione';
}

function linkLabel(fieldName) {
    const key = fieldName.toLocaleLowerCase('it');
    if (/gpx/.test(key)) return 'Scarica la traccia GPX ↗';
    if (/foto|image|immagine|picture/.test(key)) return 'Apri l’immagine ↗';
    if (/scheda|profil/.test(key)) return 'Apri la scheda ↗';
    if (/trailer|media|video/.test(key)) return 'Apri il contenuto multimediale ↗';
    return 'Visita il collegamento ↗';
}

function formattedValue(field, value) {
    const raw = String(value).trim();
    const key = fieldToken(field.name).toLocaleLowerCase('it');
    const url = safeUrl(raw);
    if (url) return `<a href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer">${linkLabel(key)}</a>`;
    if (/^(e_?mail|email2?)$/i.test(key) && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(raw)) {
        return `<a href="mailto:${escapeHtml(raw)}">${escapeHtml(raw)}</a>`;
    }
    if (/^(tel|telefono|recapiti)$/i.test(key)) {
        const phone = raw.replace(/[^+\d]/g, '');
        return phone.length >= 6 ? `<a href="tel:${escapeHtml(phone)}">${escapeHtml(raw)}</a>` : escapeHtml(raw);
    }
    const dateLike = field.type === 'esriFieldTypeDate' || /^(date|time|date_bg|date_end|ult_rev)$/i.test(key);
    if (dateLike) {
        const date = /^\d{11,13}$/.test(raw) ? new Date(Number(raw)) : new Date(raw);
        if (!Number.isNaN(date.getTime())) return escapeHtml(new Intl.DateTimeFormat('it-IT', { dateStyle: 'long', timeStyle: /time/i.test(key) ? 'short' : undefined }).format(date));
    }
    if (/^blu_\d+$/i.test(key) && /^(0|1|true|false|si|sì|no)$/i.test(raw)) {
        return /^(1|true|si|sì)$/i.test(raw) ? 'Sì' : 'No';
    }
    if (/^-?\d+(?:[.,]\d+)?$/.test(raw) && raw.length < 16) {
        const number = Number(raw.replace(',', '.'));
        if (Number.isFinite(number)) {
            let suffix = '';
            if (/^(depth|prof|altezza|elevation)$/i.test(key)) suffix = ' m';
            else if (/^(area__ha_)$/i.test(key)) suffix = ' ha';
            else if (/^(lunghezza|lungint|distanza__)$/i.test(key)) suffix = ' km';
            return escapeHtml(number.toLocaleString('it-IT', { maximumFractionDigits: 3 }) + suffix);
        }
    }
    return escapeHtml(raw.replace(/[_]+/g, ' '));
}

function fieldPriority(field) {
    const key = fieldToken(field.name).toLocaleLowerCase('it');
    if (/^(accomdesc|name|nome|denom|denomi|denominazi|denomin|denom_it|titolo)$/.test(key)) return 100;
    if (/^(comune|geogareaname|localit|località|localiz|localizzaz|prov|provincia|indirizzo|address|place)$/.test(key)) return 90;
    if (/^(tipo|type|tipologia|tipology|classification|categoria|sotto_tipo|specie|cronologia)$/.test(key)) return 80;
    if (/^(descriz|descriptio|sintesi|abstract|info|note|note_|notes|orario|visitabile)$/.test(key)) return 70;
    if (/email|mail|tel|website|url|web|link|scheda|gpx|foto|image|immagine|trailer/.test(key)) return 60;
    if (/^(circode|cincode)$/.test(key)) return 50;
    if (/^(id|entitycod|geogareacod|sigla|codarc)/.test(key)) return 5;
    return 30;
}

async function fetchJson(url, timeoutMs = 30000) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
        const response = await fetch(url, { cache: 'default', credentials: 'same-origin', signal: controller.signal });
        const payload = await response.json();
        if (!response.ok || payload.success !== true) {
            throw new Error(payload?.error?.message || `HTTP ${response.status}`);
        }
        return payload;
    } finally {
        clearTimeout(timer);
    }
}

export function getGeoportaleCatalog() {
    if (!state.catalogPromise) {
        state.catalogPromise = fetchJson(API + 'action=catalog', 20000).then(payload => {
            state.catalog = payload.data;
            return state.catalog;
        }).catch(error => {
            state.catalogPromise = null;
            throw error;
        });
    }
    return state.catalogPromise;
}

function itemByKey(key) {
    return state.catalog?.items?.find(item => item.key === key) || null;
}

function sourceId(key) { return 'ws-geo-' + key; }
function fillId(key) { return sourceId(key) + '-fill'; }
function outlineId(key) { return sourceId(key) + '-outline'; }
function pointId(key) { return sourceId(key) + '-point'; }
function lineId(key) { return sourceId(key) + '-line'; }
function rasterId(key) { return sourceId(key) + '-raster'; }

function auditFeatureCount(item) {
    return Number(item.audit?.feature_count || 0);
}

function hasOnlyNullGeometry(item) {
    const counts = item.audit?.geometry_counts || {};
    const total = auditFeatureCount(item);
    return item.kind === 'vector' && total > 0 && Number(counts.null || 0) === total;
}

function shouldCluster(item) {
    return item.kind === 'vector' && item.geometry_type === 'esriGeometryPoint' && auditFeatureCount(item) >= 2000;
}

function selectorValue(value) {
    if (globalThis.CSS?.escape) return CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
}

function layerIds(item) {
    if (item.kind === 'raster') return [rasterId(item.key)];
    if (item.geometry_type === 'esriGeometryPolygon') return [fillId(item.key), outlineId(item.key)];
    if (item.geometry_type === 'esriGeometryPolyline') return [lineId(item.key)];
    return [pointId(item.key)];
}

function beforeId() {
    const map = state.map;
    for (const id of ['ws-stations-symbols', 'ws-stations-circles', 'ws-forecast-symbols']) {
        if (map?.getLayer(id)) return id;
    }
    return undefined;
}

function ensureVector(item) {
    const map = state.map;
    const sid = sourceId(item.key);
    if (map.getSource(sid)) return;
    const sourceOptions = {
        type: 'geojson', data: EMPTY,
        attribution: item.attribution || '© Osservatorio Turistico - Regione Siciliana',
    };
    if (shouldCluster(item)) Object.assign(sourceOptions, { cluster: true, clusterRadius: 48, clusterMaxZoom: 13 });
    map.addSource(sid, sourceOptions);
    const color = item.color || '#0284c7';
    const before = beforeId();
    if (item.geometry_type === 'esriGeometryPolygon') {
        map.addLayer({
            id: fillId(item.key), type: 'fill', source: sid,
            paint: { 'fill-color': color, 'fill-opacity': 0.2 },
        }, before);
        map.addLayer({
            id: outlineId(item.key), type: 'line', source: sid,
            paint: { 'line-color': color, 'line-width': 2, 'line-opacity': 0.9 },
        }, before);
    } else if (item.geometry_type === 'esriGeometryPolyline') {
        map.addLayer({
            id: lineId(item.key), type: 'line', source: sid,
            paint: {
                'line-color': color,
                'line-width': ['interpolate', ['linear'], ['zoom'], 6, 1.4, 11, 3.2, 15, 5],
                'line-opacity': 0.9,
            },
        }, before);
    } else {
        map.addLayer({
            id: pointId(item.key), type: 'circle', source: sid,
            paint: {
                'circle-radius': ['case', ['has', 'point_count'],
                    ['step', ['get', 'point_count'], 11, 25, 15, 250, 20, 2500, 26],
                    6],
                'circle-color': color,
                'circle-opacity': ['case', ['has', 'point_count'], 0.72, 0.88],
                'circle-stroke-color': '#ffffff',
                'circle-stroke-width': ['case', ['has', 'point_count'], 2.5, 1.5],
            },
        }, before);
    }
    wireInteractions(item);
}

function ensureRaster(item) {
    const map = state.map;
    const sid = sourceId(item.key);
    if (map.getSource(sid)) return;
    const tile = `${API}action=tile&dataset=${encodeURIComponent(item.key)}&z={z}&x={x}&y={y}`;
    map.addSource(sid, {
        type: 'raster', tiles: [tile], tileSize: 256,
        attribution: item.attribution || '© Osservatorio Turistico - Regione Siciliana',
    });
    map.addLayer({
        id: rasterId(item.key), type: 'raster', source: sid,
        paint: { 'raster-opacity': 0.82, 'raster-fade-duration': 180 },
    }, beforeId());
}

function preferredTitle(item, properties) {
    const candidates = [...(item.fields || [])].sort((a, b) => fieldPriority(b) - fieldPriority(a));
    const preferred = candidates.find(field => {
        const key = fieldToken(field.name).toLocaleLowerCase('it');
        return /^(accomdesc|nome|name|titolo|title|denom|denomi|denominazi|denominazione|denom_it|percorso|cammino|sito|struttura|nome_porto)$/.test(key)
            && properties[field.name] != null && String(properties[field.name]).trim() !== '';
    });
    if (preferred) {
        return String(properties[preferred.name]).replace(/[_]+/g, ' ');
    }
    return prettyLayerTitle(item);
}

function propertyRows(item, properties) {
    const fields = new Map((item.fields || []).map(field => [field.name, field]));
    const entries = Object.entries(properties).map(([key, value], index) => {
        const field = fields.get(key) || { name: key, alias: key, type: '' };
        return { key, value, field, index, priority: fieldPriority(field) };
    }).filter(({ key, value }) => {
        if (value == null || typeof value === 'object') return false;
        const text = String(value).trim();
        if (text === '' || /^(null|n\/a|nd|n\.d\.|-|\.)$/i.test(text)) return false;
        if (TECHNICAL_FIELD.test(key) || /(^|\.)(shape|globalid|objectid(?:_\d+)?)$/i.test(key)) return false;
        const token = fieldToken(key).toLocaleLowerCase('it');
        if (/^(id|id_.+|.+_id|ico_.+|image_ico|et_id|rifmaz|num|field)$/.test(token)) return false;
        if (/^(latn|lat_n|latitude|longe|long_e|longitude|gpsx|gpsy|gps_x|gps_y|xlong|ylat)$/.test(token)) return false;
        return true;
    }).sort((a, b) => b.priority - a.priority || a.index - b.index);

    const row = ({ field, value }) => `<div><dt>${escapeHtml(fieldLabel(field))}</dt><dd>${formattedValue(field, value)}</dd></div>`;
    const main = entries.slice(0, 10).map(row).join('');
    const extra = entries.slice(10, 70).map(row).join('');
    return {
        main,
        extra,
        total: entries.length,
        omitted: Math.max(0, entries.length - 70),
    };
}

function propertyByName(properties, name) {
    const wanted = String(name || '').toLocaleLowerCase('it');
    const key = Object.keys(properties).find(candidate => candidate.toLocaleLowerCase('it') === wanted);
    return key ? properties[key] : null;
}

function popupImageHtml(item, properties, title) {
    const attachment = Number(propertyByName(properties, 'AttachID'));
    const oid = Number(propertyByName(properties, item.object_id_field || 'OBJECTID'));
    let imageUrl = null;
    if (Number.isInteger(attachment) && attachment > 0 && Number.isInteger(oid) && oid > 0) {
        imageUrl = `${API}action=attachment&dataset=${encodeURIComponent(item.key)}&oid=${oid}&attachment=${attachment}`;
    } else {
        for (const [key, value] of Object.entries(properties)) {
            if (!/(foto|photo|image|immagine|picture)/i.test(key)) continue;
            const candidate = safeUrl(value);
            if (candidate) { imageUrl = candidate; break; }
        }
    }
    if (!imageUrl) return '';
    return `<figure class="ws-geo-popup__image">
        <a href="${escapeHtml(imageUrl)}" target="_blank" rel="noopener noreferrer" title="Apri l’immagine originale">
            <img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(title)}" loading="lazy" decoding="async">
            <figcaption>Apri l’immagine originale ↗</figcaption>
        </a>
    </figure>`;
}

function popupHtml(item, properties, coordinates) {
    const title = preferredTitle(item, properties);
    const rows = propertyRows(item, properties);
    const source = safeUrl(item.source_url);
    const image = popupImageHtml(item, properties, title);
    const coords = Array.isArray(coordinates) && coordinates.length >= 2
        ? `${Number(coordinates[1]).toLocaleString('it-IT', { maximumFractionDigits: 5 })}, ${Number(coordinates[0]).toLocaleString('it-IT', { maximumFractionDigits: 5 })}`
        : null;
    return `<article class="ws-geo-popup">
        <header style="--geo-color:${escapeHtml(item.color || '#0284c7')}">
            <span>${escapeHtml(item.icon || '📍')}</span>
            <div><small>${escapeHtml(item.category_label)} · ${escapeHtml(prettyLayerTitle(item))}</small><h3>${escapeHtml(title)}</h3></div>
        </header>
        ${image}
        ${rows.main ? `<section class="ws-geo-popup__facts"><h4>Informazioni principali</h4><dl>${rows.main}</dl></section>` : '<p>Informazioni geografiche regionali.</p>'}
        ${rows.extra ? `<details class="ws-geo-popup__more"><summary>Altri dettagli (${Math.min(rows.total - 10, 60)})</summary><dl>${rows.extra}</dl>${rows.omitted ? `<small>${rows.omitted} campi tecnici non mostrati.</small>` : ''}</details>` : ''}
        ${coords ? `<div class="ws-geo-popup__coords"><span>Coordinate</span><b>${escapeHtml(coords)}</b></div>` : ''}
        <footer>
            <b>Provenienza del dato</b>
            <span>${escapeHtml(item.attribution || '© Osservatorio Turistico - Regione Siciliana')}</span>
            ${item.license ? `<span><strong>Licenza:</strong> ${escapeHtml(item.license)}</span>` : ''}
            ${source ? `<a href="${escapeHtml(source)}" target="_blank" rel="noopener noreferrer">Metadati e fonte ↗</a>` : ''}
        </footer>
    </article>`;
}

function wireInteractions(item) {
    if (state.wired.has(item.key)) return;
    state.wired.add(item.key);
    const map = state.map;
    for (const id of layerIds(item)) {
        if (id === outlineId(item.key)) continue;
        map.on('mouseenter', id, () => { map.getCanvas().style.cursor = 'pointer'; });
        map.on('mouseleave', id, () => { map.getCanvas().style.cursor = ''; });
        map.on('click', id, event => {
            const feature = event.features?.[0];
            if (!feature) return;
            if (feature.properties?.cluster && feature.properties?.cluster_id != null) {
                const source = map.getSource(sourceId(item.key));
                Promise.resolve(source?.getClusterExpansionZoom(Number(feature.properties.cluster_id)))
                    .then(zoom => {
                        if (Number.isFinite(zoom)) map.easeTo({ center: feature.geometry.coordinates, zoom });
                    }).catch(() => {});
                return;
            }
            if (state.popup) state.popup.remove();
            const coordinates = feature.geometry?.type === 'Point'
                ? feature.geometry.coordinates
                : [event.lngLat.lng, event.lngLat.lat];
            state.popup = new maplibregl.Popup({
                closeButton: true, closeOnClick: true, offset: 12,
                className: 'ws-geo-popup-shell', maxWidth: '380px',
            }).setLngLat(coordinates).setHTML(popupHtml(item, feature.properties || {}, coordinates)).addTo(map);
        });
    }
}

function setLayersVisible(item, visible) {
    for (const id of layerIds(item)) {
        if (state.map?.getLayer(id)) state.map.setLayoutProperty(id, 'visibility', visible ? 'visible' : 'none');
    }
}

function syncControlState(key, patch = {}) {
    const row = state.controls?.querySelector(`[data-geo-key="${selectorValue(key)}"]`);
    if (!row) return;
    row.classList.toggle('is-loading', !!patch.loading);
    row.classList.toggle('has-error', !!patch.error);
    const checkbox = row.querySelector('input');
    if (checkbox && typeof patch.checked === 'boolean') checkbox.checked = patch.checked;
    const status = row.querySelector('small');
    if (status && patch.status != null) status.textContent = patch.status;
}

function persistEnabled() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify([...state.enabled])); } catch (e) {}
}

async function applyDemo(button) {
    button.disabled = true;
    button.textContent = 'Preparazione demo…';
    for (const key of DEMO_KEYS) {
        if (itemByKey(key)) await setGeoportaleEnabled(key, true);
    }
    button.disabled = false;
    button.textContent = 'Demo turismo attiva ✓';
}

async function clearAll(button) {
    button.disabled = true;
    for (const key of [...state.enabled]) await setGeoportaleEnabled(key, false, false);
    persistEnabled();
    button.disabled = false;
}

export async function setGeoportaleEnabled(key, enabled, persist = true) {
    await getGeoportaleCatalog();
    const item = itemByKey(key);
    if (!item) return false;
    if (enabled && (hasOnlyNullGeometry(item) || item.duplicate_of)) return false;
    if (!enabled) {
        state.enabled.delete(key);
        setLayersVisible(item, false);
        syncControlState(key, { checked: false, loading: false, error: false, status: '' });
        if (persist) persistEnabled();
        return true;
    }
    state.enabled.add(key);
    if (persist) persistEnabled();
    if (!state.map) {
        syncControlState(key, { checked: true, status: 'in attesa' });
        return true;
    }
    state.loading.add(key);
    syncControlState(key, { checked: true, loading: true, error: false, status: 'caricamento…' });
    try {
        if (item.kind === 'raster') {
            ensureRaster(item);
            setLayersVisible(item, true);
            syncControlState(key, { checked: true, loading: false, status: 'mappa storica' });
        } else {
            ensureVector(item);
            setLayersVisible(item, true);
            const payload = await fetchJson(`${API}action=layer&dataset=${encodeURIComponent(key)}`, 45000);
            if (!state.enabled.has(key)) return true;
            const source = state.map.getSource(sourceId(key));
            source?.setData(payload.data || EMPTY);
            const count = Number(payload.meta?.mapped_feature_count ?? payload.data?.features?.length ?? 0);
            const skipped = Number(payload.meta?.skipped_without_geometry || 0);
            const suffix = skipped ? ` · ${skipped.toLocaleString('it-IT')} senza posizione esclusi` : '';
            syncControlState(key, { checked: true, loading: false, status: `${count.toLocaleString('it-IT')} elementi${suffix}` });
        }
        return true;
    } catch (error) {
        state.enabled.delete(key);
        setLayersVisible(item, false);
        syncControlState(key, { checked: false, loading: false, error: true, status: 'non disponibile' });
        persistEnabled();
        console.error('[Geoportale Sicilia]', key, error);
        return false;
    } finally {
        state.loading.delete(key);
    }
}

function geometryGlyph(item) {
    if (item.kind === 'raster') return '▧';
    if (item.geometry_type === 'esriGeometryPolygon') return '⬟';
    if (item.geometry_type === 'esriGeometryPolyline') return '〰';
    return '●';
}

function buildControl(item) {
    const label = document.createElement('label');
    const title = prettyLayerTitle(item);
    const serviceTitle = prettyServiceTitle(item);
    const context = serviceTitle && serviceTitle.toLocaleLowerCase('it') !== title.toLocaleLowerCase('it')
        ? serviceTitle : item.category_label;
    label.className = 'wsv2-toggle ws-geo-toggle';
    const unavailable = hasOnlyNullGeometry(item);
    const duplicate = !!item.duplicate_of;
    const auditedCount = auditFeatureCount(item);
    const initialStatus = unavailable
        ? 'tabella senza geometrie'
        : duplicate
            ? 'duplicato già incluso'
            : item.audit?.truncated
                ? `${auditedCount.toLocaleString('it-IT')} elementi · sorgente oltre limite`
                : auditedCount
                    ? `${auditedCount.toLocaleString('it-IT')} elementi verificati`
                    : '';
    if (unavailable || duplicate) label.classList.add('is-unavailable');
    label.dataset.geoKey = item.key;
    label.dataset.search = `${title} ${item.title} ${serviceTitle} ${item.description || ''}`.toLocaleLowerCase('it');
    label.innerHTML = `<span><i style="--geo-color:${escapeHtml(item.color)}">${geometryGlyph(item)}</i>${escapeHtml(title)}<em>${escapeHtml(context)}</em></span>
        <small>${escapeHtml(initialStatus)}</small><input type="checkbox" id="geo-${escapeHtml(item.key)}" ${(unavailable || duplicate) ? 'disabled' : ''}><i class="wsv2-switch" aria-hidden="true"></i>`;
    label.querySelector('input').addEventListener('change', event => setGeoportaleEnabled(item.key, event.target.checked));
    return label;
}

export async function initGeoportaleControls(container) {
    state.controls = container;
    container.innerHTML = '<div class="ws-geo-loading">Caricamento catalogo regionale…</div>';
    try {
        const catalog = await getGeoportaleCatalog();
        const items = catalog.items || [];
        const intro = document.createElement('div');
        intro.className = 'ws-geo-intro';
        const audit = catalog.audit?.summary;
        const auditText = audit ? `${audit.total} layer verificati · ${audit.error} errori tecnici` : `${items.length} layer regionali disponibili`;
        intro.innerHTML = `<b>Geoportale Sicilia</b><span>${escapeHtml(auditText)}</span>
            <a href="${escapeHtml(catalog.source.presentation_url)}" target="_blank" rel="noopener noreferrer">Fonte ufficiale ↗</a>
            <div><button type="button" data-geo-demo>▶ Demo turismo</button><button type="button" data-geo-clear>Spegni tutti</button></div>`;
        intro.querySelector('[data-geo-demo]').addEventListener('click', event => applyDemo(event.currentTarget));
        intro.querySelector('[data-geo-clear]').addEventListener('click', event => clearAll(event.currentTarget));
        const search = document.createElement('input');
        search.type = 'search';
        search.className = 'wsv2-select ws-geo-search';
        search.placeholder = 'Cerca sentieri, musei, spiagge…';
        search.setAttribute('aria-label', 'Cerca nei layer del Geoportale Sicilia');
        const groups = document.createElement('div');
        groups.className = 'ws-geo-categories';
        for (const category of CATEGORY_ORDER) {
            const categoryItems = items.filter(item => item.category === category);
            if (!categoryItems.length) continue;
            const section = document.createElement('section');
            section.className = 'ws-geo-category';
            section.dataset.category = category;
            section.innerHTML = `<h4>${escapeHtml(categoryItems[0].icon)} ${escapeHtml(categoryItems[0].category_label)} <span>${categoryItems.length}</span></h4>`;
            for (const item of categoryItems) section.appendChild(buildControl(item));
            groups.appendChild(section);
        }
        search.addEventListener('input', () => {
            const needle = search.value.trim().toLocaleLowerCase('it');
            groups.querySelectorAll('.ws-geo-toggle').forEach(row => {
                row.hidden = !!needle && !row.dataset.search.includes(needle);
            });
            groups.querySelectorAll('.ws-geo-category').forEach(section => {
                section.hidden = ![...section.querySelectorAll('.ws-geo-toggle')].some(row => !row.hidden);
            });
        });
        container.replaceChildren(intro, search, groups);
        for (const key of state.enabled) syncControlState(key, { checked: true });
    } catch (error) {
        container.innerHTML = `<div class="ws-geo-error">Catalogo regionale temporaneamente non disponibile.<button type="button">Riprova</button></div>`;
        container.querySelector('button')?.addEventListener('click', () => initGeoportaleControls(container));
    }
}

export async function initGeoportaleSicilia(map) {
    state.map = map;
    await getGeoportaleCatalog();
    let restored = [];
    try {
        const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        if (Array.isArray(value)) restored = value.filter(key => typeof key === 'string').slice(0, 12);
    } catch (e) {}
    for (const key of restored) {
        state.enabled.add(key);
        syncControlState(key, { checked: true });
        // Sequenziale: impedisce che un reload apra decine di connessioni verso
        // il GIS regionale. Il limite di 12 e' una protezione intenzionale.
        await setGeoportaleEnabled(key, true, false);
    }
}
